import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Head from "next/head";
import React, { useEffect } from "react";
import { useAtomDevtools } from "jotai/devtools";
import { SWRConfig } from "swr";
import { Conditional } from "dyson/src/components/layouts";
import { Snackbar } from "@ui/containers/common/Snackbar";
import { LoadingScreen } from "@ui/layout/LoadingScreen";
import { loadGTM, loadGA, loadSegment } from "@utils/common/scriptUtils";
import { useBasicSEO } from "../src/hooks/seo";
import { usePageSegmentAnalytics } from "../src/hooks/analytics";
import { useLoadTempData } from "../src/hooks/tempTest";
import { loadUserDataAndRedirect } from "../src/hooks/user";
import { rootGlobalAtom } from "../src/store/atoms/global/rootAtom";
import "../src/tailwind.css";
import { jsx as ___EmotionJSX } from "@emotion/core";

function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  useLoadTempData();

  var _loadUserDataAndRedir = loadUserDataAndRedirect({
    fetchData: true,
    userAndSystemData: null
  }),
      _loadUserDataAndRedir2 = _slicedToArray(_loadUserDataAndRedir, 1),
      userDataLoaded = _loadUserDataAndRedir2[0]; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore


  useAtomDevtools(rootGlobalAtom);
  useBasicSEO({
    favicon: "/assets/img/favicon.png"
  });
  usePageSegmentAnalytics();
  useEffect(function () {
    setTimeout(function () {
      loadGA();
      loadSegment();
      loadGTM();
    }, 4000);
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Head, null, ___EmotionJSX("meta", {
    name: "referrer",
    content: "origin"
  }), ___EmotionJSX("meta", {
    name: "viewport",
    content: "initial-scale=1.0, width=device-width"
  })), ___EmotionJSX(SWRConfig, {
    value: {
      fetcher: function fetcher(resource, init) {
        return fetch(resource, _objectSpread(_objectSpread({}, init), {}, {
          credentials: "include",
          headers: _objectSpread({}, init && init.headers ? init.headers : {})
        })).then(function (res) {
          return res.json();
        });
      }
    }
  }, ___EmotionJSX(Conditional, {
    showIf: !userDataLoaded
  }, ___EmotionJSX(LoadingScreen, null)), ___EmotionJSX(Conditional, {
    showIf: userDataLoaded
  }, ___EmotionJSX(Component, pageProps)), ___EmotionJSX(Snackbar, null)));
}

export default App;